// extracted by css-extract-rspack-plugin
export default {"iframe":"_80274d74","thumbnail":"_f3a300c"};